import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  modal: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    borderWidth: 0,
  },
  container: {
    flex: 1,
    backgroundColor: '#000',
    opacity: 0.6,
  },
  modalBox: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    justifyContent: 'center',
  },
  modalContentLarge: {
    backgroundColor: '#fff',
    width: '30%',
    height: '30%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modalContentSmall: {
    backgroundColor: '#fff',
    width: '80%',
    height: '35%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  modaIconContainer: {
    position: 'absolute',
    top: -30,
    zIndex: 100,
    borderRadius: 35,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    width: 70,
    height: 70,
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
    padding: 5,
  },
  modalTextContainer: {
    flex: 0.3,
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: 30,
    marginBottom: 10,
  },
  modalText: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
  errorText: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    color: '#F00',
  },
});
